function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-1258.000000, -86.000000)",
  fill: "#2D3846",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(1259.000000, 86.000000)"
}, React.createElement("polygon", {
  points: "-0.689655172 1.5314296 0.689655172 0.0831537356 19.9709052 18.446249 18.5915948 19.8945248"
}), React.createElement("polygon", {
  transform: "translate(9.640625, 9.988839) scale(-1, 1) translate(-9.640625, -9.988839) ",
  points: "-0.689655172 1.5314296 0.689655172 0.0831537356 19.9709052 18.446249 18.5915948 19.8945248"
}))));

const SvgCloseIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "21px",
  height: "20px",
  viewBox: "0 0 21 20",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-icon.9fbec875.svg";
export { ForwardRef as ReactComponent };